import React from 'react';
import './ToolModeBanner.css';

interface ToolModeBannerProps {
  variant: 'delete' | 'wall';
  message: string;
  exitLabel: string;
  onExit: () => void;
}

const ToolModeBanner: React.FC<ToolModeBannerProps> = ({ variant, message, exitLabel, onExit }) => (
  <div className={`tool-mode-banner tool-mode-banner--${variant}`}>
    <span>{message}</span>
    <button
      type="button"
      className="tool-mode-banner__exit"
      onClick={(event) => {
        event.stopPropagation();
        onExit();
      }}
    >
      {exitLabel}
    </button>
  </div>
);

export default ToolModeBanner;
